app.service("tooltip", function (html, front, broker) {
	let $self, $btnClose, $body, $currentElement;

	function setElements() {
		$body = $('body');
		$self = $('<div id="tooltip"></div>');
		$btnClose = $('<button class="btn-hide-tooltip"></button>');
		$('body').append($self);
	}

	function handleKeyDown(event) {
		if (event.key == ' ') {
			event.preventDefault();
			event.stopPropagation();
		}
	}
	function handleClick(event) {
		$currentElement = $(this);
		toggleTooltip();
		event.preventDefault();
		event.stopPropagation();
	}
	function handleKeyUp(event) {
		if (['Enter', 'NumpadEnter', 'Space', 'Escape'].includes(event.code)) {
			$currentElement = $(this);
			toggleTooltip();
			event.preventDefault();
			event.stopPropagation();
		}
	}
	function setEventOnElement(parent) {
		const $parent = parent ? parent : $('body');
		$('.js-show-tooltip-and-stop', $parent)
			.on('click', handleClick)
			.on('keyup', handleKeyUp)
			.on('keydown', handleKeyDown);
	}

	function setEvents() {
		$(window).resize(() => {
			if (html.has('show-tooltip')) {
				setPosition();
			}
		});

		$('body')
			.on('click', function (e) {
				if (html.has('show-tooltip') && !e.target.closest('.tooltip-content')) {
					hideTooltip();
				}
			})
			.on('click', '.js-show-tooltip', handleClick)
			.on('keyup', '.js-show-tooltip', handleKeyUp)
			.on('keydown', '.js-show-tooltip', handleKeyDown);
		$($self).on('click', '.btn-hide-tooltip', () => {
			hideTooltip();
		});
	}

	function toggleTooltip() {
		!html.has('show-tooltip') ? showTooltip() : hideTooltip();
	}

	function showTooltip() {
		const id = $currentElement.data('tooltip-id');
		const message = id ? $(`#${id}`).html() : $('.tooltip-message', $currentElement).html();
		setContent(message);
		setPosition();
		html.add('show-tooltip');
	}

	function hideTooltip() {
		html.remove('show-tooltip');
	}

	function setPosition() {
		const arrowWidth = 10;
		const padding = 16;
		let arrowLeftPosition = 18;
		let left, top;

		if ($currentElement.length) {
			const bodyRect = $body[0].getBoundingClientRect();
			const tooltipRect = $self[0].getBoundingClientRect();
			const currentElementRect = $currentElement[0].getBoundingClientRect();

			if (currentElementRect.right + padding < tooltipRect.width) {
				left = 0;
			} else {
				left = currentElementRect.right + padding - tooltipRect.width;
			}

			if ($currentElement.hasClass('show-tooltip-text')) {
				arrowLeftPosition = currentElementRect.right - left - padding;
			} else {
				arrowLeftPosition = currentElementRect.right - left - currentElementRect.width / 2 - arrowWidth / 2;
			}

			$self.removeClass('under');
			if (currentElementRect.top < tooltipRect.height) {
				top = currentElementRect.top + window.pageYOffset + currentElementRect.height;
				$self.addClass('under');
			} else {
				top = currentElementRect.top + window.pageYOffset - tooltipRect.height;
			}

			$self.css({ top: top, left: left });
			$self[0].style.setProperty('--arrow-left-position', `${arrowLeftPosition}px`);
		}
	}

	function setContent(message) {
		$self.html(message);
		$self.prepend($btnClose);
	}
	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			setElements();
			setEvents();
			broker.on('RELOAD_CART_SUCCESS', function() {
				setEventOnElement();
			});
		}
		setEventOnElement();	// to zdarzenie musi być nakładane co zminę strony ajaxowej
	}

	return {
		init,
		setEventOnElement
	};
});
